
import { canonical } from "@utils";
import { getCMSCopy } from "@/common/services/cmsCopyService";

export default {
	name: "Reviews",
	async asyncData({ $axios, $config }) {
		const cmsCopyKey = ".seo.landing.reviews";
		const cmsCopy = await getCMSCopy(
			$axios,
			$config,
			cmsCopyKey,
			process.env.version
		);

		return {
			pageTitle: cmsCopy?.data?.title || "",
			pageHeading: cmsCopy?.data?.teaser || "",
			pageContent: cmsCopy?.data?.body || "",
			pageMetaTitle: cmsCopy?.data?.metaTitle || "",
			pageMetaDescription: cmsCopy?.data?.metaDescription || "",
		};
	},
	head() {
		return {
			title: this.pageMetaTitle,
			meta: [
				{
					name: "description",
					content: this.pageMetaDescription,
				},
			],
			link: [canonical(this.$route)],
		};
	},
};
